import React from 'react'
import { OrderDayCounterWrapper } from './index.styled'

const OrderDayCounter = React.memo(({ item }) => {
	const dayCounter = item.orderDayCounter
	const canceledDayCounter = item.orderCanceledDayCounter
	const hasBothCounters = dayCounter != null && canceledDayCounter != null

	return (
		<>
			{dayCounter != null && <OrderDayCounterWrapper className={hasBothCounters ? 'cancelled' : ''}>{dayCounter}</OrderDayCounterWrapper>}
			{canceledDayCounter != null && <OrderDayCounterWrapper>{canceledDayCounter}</OrderDayCounterWrapper>}
		</>
	)
})

OrderDayCounter.displayName = 'OrderDayCounter'
export default OrderDayCounter
